import React from "react";
import { Spinner } from "react-bootstrap";
import OrderRow from "./OrderRow";

const OrderTable = ({
  orders,
  loading,
  page,
  pageSize,
  quantityView,
  onQuantityViewChange,
  expandQuantityView,
  onExpandQuantityViewChange,
  dispatchDatesMap,
  onDispatchDateChange,
  onSaveDispatchDate,
  savingDispatchId,
  dispatchDatePermission,
  actions,
  onEdit,
  onDelete,
  onQuantity,
  onStatusChange,
  onProductClick,
  onAddQueue,
  onMediaPreview,
  onViewLogs,
  onStatusLabelClick,
  truncateText,
  formatDate,
  renderDateDifference,
  showCurrentDateDiff,
  statusFilter,
  statusOptions,
}) => {
  if (loading) {
    return (
      <div className="text-center py-4">
        <Spinner animation="border" variant="primary" />
      </div>
    );
  }

  if (orders.length === 0) {
    return (
      <div className="text-center py-4">
        No {statusFilter === 'all' ? '' : statusFilter} orders found
      </div>
    );
  }

  return (
    <div className="table-responsive">
      <table className="table bordered-table mb-0 compact-table" style={{ fontSize: "0.85rem" }}>
        <thead>
          <tr>
            <th className="table-header-text">ID & NAME</th>
            <th className="table-header-text">DESIGN</th>
            <th>
              <div className="d-flex flex-column">
                <span className="mb-2 table-header-text">QTY</span>
                <div className="d-flex align-items-center gap-2">
                  <div className="d-flex align-items-center gap-2">
                    <span style={{ fontSize: "11px" }}>Pieces</span>
                    <div className="form-switch d-flex align-items-center">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        role="switch"
                        checked={quantityView === "sqft"}
                        onChange={() => onQuantityViewChange(quantityView === "pcs" ? "sqft" : "pcs")}
                        style={{ backgroundColor: "#dee2e6" }}
                      />
                    </div>
                    <span style={{ fontSize: "11px" }}>Sqft</span>
                  </div>
                </div>
              </div>
            </th>
            <th>
              <div className="d-flex flex-column">
                <span className="table-header-text mb-1">ORDER & DISPATCH</span>
                <div className="d-flex align-items-center gap-2">
                  <span style={{ fontSize: "11px" }}>Order Date</span>
                  <div className="form-switch d-flex align-items-center">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      role="switch"
                      checked={showCurrentDateDiff}
                      onChange={() => { }} // This is handled by the parent
                      style={{ backgroundColor: "#dee2e6" }}
                    />
                  </div>
                  <span style={{ fontSize: "11px" }}>Today</span>
                </div>
              </div>
            </th>
            <th className="table-header-text" style={{ width: 100 }}>Dispatch Date</th>
            <th className="table-header-text">STATUS</th>
            <th className="table-header-text">Actions</th>
          </tr>
        </thead>
        <tbody>
          {orders.map((order, index) => {

            return (
              <OrderRow
                key={`${order.orderId}-${index}`}
                order={order}
                index={index}
                page={page}
                pageSize={pageSize}
                quantityView={quantityView}
                expandQuantityView={expandQuantityView}
                onExpandQuantityViewChange={onExpandQuantityViewChange}
                dispatchDatesMap={dispatchDatesMap}
                onDispatchDateChange={onDispatchDateChange}
                onSaveDispatchDate={onSaveDispatchDate}
                savingDispatchId={savingDispatchId}
                dispatchDatePermission={dispatchDatePermission}
                actions={actions}
                onEdit={onEdit}
                onDelete={onDelete}
                onQuantity={onQuantity}
                onStatusChange={onStatusChange}
                onProductClick={onProductClick}
                onAddQueue={onAddQueue}
                onMediaPreview={onMediaPreview}
                onViewLogs={onViewLogs}
                onStatusLabelClick={onStatusLabelClick}
                truncateText={truncateText}
                formatDate={formatDate}
                renderDateDifference={renderDateDifference}
                showCurrentDateDiff={showCurrentDateDiff}
                statusOptions={statusOptions}
              />
            )

          })}
        </tbody>
      </table>
    </div>
  );
};

export default React.memo(OrderTable);